module.exports = __webpack_public_path__ + "media/assets/images/icon_gear-31ba935b7fe395ffb1e227519edb3008.png";